import { Container, Flex, VStack, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Layout = React.memo(() => {
  const { sidebar_width } = useSelector((state) => state.other);
  const location = useLocation();
  const contentRef = useRef(null);

  // Reset the content scroll to the top whenever the route changes, so each page
  // opens from the start instead of inheriting the previous page's scroll.
  useEffect(() => {
    contentRef.current?.scrollTo({ top: 0 });
  }, [location.pathname]);

  const sidebarBg  = useColorModeValue("white", "gray.900");
  const contentBg  = useColorModeValue("#FAFBFE", "gray.800");
  const borderClr  = useColorModeValue("#88888822", "whiteAlpha.100");

  return (
    <Container h="100vh" w="100vw" maxW="100vw" padding={0}>
      {/* Header */}
      <Flex w="full" h="60px">
        <Header />
      </Flex>

      {/* Body */}
      <Flex w="full" overflowY="auto" h="calc(100vh - 60px)">
        {/* Sidebar — desktop only */}
        <VStack
          display={["none", "none", "none", "flex"]}
          bg={sidebarBg}
          h="full"
          spacing={0}
        >
          <div
            style={{
              position: "relative",
              width: sidebar_width ? "13rem" : "3rem",
              transition: "width ease 0.4s",
              borderRight: `1px solid ${borderClr}`,
              overflowY: "auto",
              overflowX: "hidden",
              height: "100%",
            }}
          >
            <Sidebar />
          </div>
        </VStack>

        {/* Main content */}
        <VStack
          ref={contentRef}
          w="full"
          overflowY="scroll"
          py={3}
          bg={contentBg}
          align="stretch"
          spacing={0}
        >
          <Outlet />
        </VStack>
      </Flex>
    </Container>
  );
});

export default Layout;
